import { BaseController } from '../../common/base/controller';

export class TicketErrorController extends BaseController {
  constructor(controllerService, ticketFlowService) {
    'ngInject';
    super({ controllerService, ticketFlowService });
  }

  get error() {
    return this.$stateParams.ticketError || {};
  }

  $onInit() {
    this.setErrorStatus();
  }

  setErrorStatus() {
    const status = ['error'];
    if (this.error.code) {
      status.push(`error-${this.error.code}`);
    } else {
      status.push('unknown');
    }

    this.status = status.join(' ');
    this.errorKey = this.status.replace(' ', '-');
  }

  navigateToList() {
    const { ticketFlowService } = this;

    const state = ticketFlowService.getRouteForTicket(this.ticket, 'list');
    this.go(state);
  }
}
